import {
  type debounce as debounced,
  debounce as debounceInner,
  type throttle as throttled,
  throttle as throttleInner,
} from 'throttle-debounce'

import type { DebounceOptions, ThrottleOptions } from './types'

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  options?: DebounceOptions,
): debounced<T> {
  return debounceInner<T>(wait, func, options)
}

export function throttle<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  options?: ThrottleOptions,
): throttled<T> {
  return throttleInner<T>(wait, func, options)
}
